import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExport from '../../../../components/ExcelExport';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetYurticiCargoListPagingAndFilterRequest } from '../../../../models/request/yurticiCargo/GetYurticiCargoListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableActions from '../../../../components/TableActions';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { GetCountryListResponseData } from '../../../../models/response/country/GetCountryListResponse';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetYurticiCargoListPagingAndFilterRequest
    getData: (_filter?: GetYurticiCargoListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetYurticiCargoListPagingAndFilterRequest>>
    selectedCount: number
    navigateToFindPrice: () => void
    updatePo: () => Promise<void>
    trCountry: GetCountryListResponseData | undefined
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
    completeMissingInvoices: () => void
}

const YurticiCargoListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    navigateToFindPrice,
    updatePo,
    trCountry,
    deleteFunction,
    onSearchSubmit,
    completeMissingInvoices,
    updateFunction
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <TableActions
                list={[
                    { isDisabled: selectedCount == 0, text: 'Toplu Fiyat Bulma', onClick: navigateToFindPrice },
                    { isDisabled: selectedCount == 0, text: 'Bölüm / PO / PO Number Güncelleme', onClick: updatePo },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026, Burak): paneldeki her alanın karşılığı
                artık kolon başlığının altındaki filtrede var (Sipariş/Yükleme Tarihi, Müşteri,
                Gönderici, Alıcı, Bölüm, PO, İller, Kargo Bölgesi, Statü, fatura durumları,
                "Beklenen Gelir/Gider Yok", Çıkış/Varış Birimi). */}

            {/* Faturası eksik kargoların numarasını Yurtiçi'den tamamlar. Tarih
                penceresine takılmaz; penceresi geçmiş eski kargolara da ulaşır. */}
            <div className='m-0 me-2'>
                <a onClick={completeMissingInvoices} className='btn btn-sm fw-bold btn-light-success'>
                    Eksik Faturaları Tamamla
                </a>
            </div>

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/yurticicargo/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Yurtiçi Kargo Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default YurticiCargoListFilters;